import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import { Container } from '../../../components';
import { cn, resultIf } from '../../../utils';
import styles from './HowItWorksNavigation.module.scss';

const links = [
  { to: '.', end: true, label: 'Как это работает' },
  { to: 'faq', end: false, label: 'FAQ' },
];

export const HowItWorksNavigation = () => {
  return (
    <>
      <nav className={styles.nav} aria-label="Разделы «Как это работает»">
        <Container>
          <ul className={styles.list}>
            {links.map(({ to, end, label }) => (
              <li className={styles.item} key={to}>
                <NavLink
                  to={to}
                  end={end}
                  className={({ isActive }) =>
                    cn(styles.link, resultIf(isActive, styles.linkActive))
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </Container>
      </nav>
      <Outlet />
    </>
  );
};
